import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const Result = () => {
  const { school, course_code, canvas_id } = useParams();
  const [result, setResult] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    let intervalId; // We'll store the interval ID here

    const fetchResults = async () => {
      try {
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        const raw = JSON.stringify({
          course_code: course_code,
          school: school,
        });

        const requestOptions = {
          method: "POST",
          headers: myHeaders,
          body: raw,
          redirect: "follow",
        };

        const response = await fetch(
          "https://be.aristai.io/api/video_a11y/get",
          requestOptions
        );
        const res = await response.json();
        setResult(res);

        // Check if there are any processing items
        const stillProcessing = res.some((item) => !item.is_finished);
        // If nothing is processing, clear the interval so we stop refetching
        if (!stillProcessing) {
          clearInterval(intervalId);
        }
      } catch (error) {
        console.error("Error fetching results:", error);
      }
    };

    // Fetch immediately
    fetchResults();

    // Then continue to fetch every 10 seconds
    intervalId = setInterval(fetchResults, 10000);

    // Cleanup when the component unmounts or school/course_code changes
    return () => {
      clearInterval(intervalId);
    };
  }, [school, course_code]);

  // Separate the data based on `is_finished`
  const processingResults = result.filter((item) => !item.is_finished);
  const finishedResults = result.filter((item) => item.is_finished);

  return (
    <div className="main-body">
      {/* Top Bar with Logo */}
      <div className="top-bar">
        <img className="logo" src="/logo.svg" alt="logo" />

        <button className="back-button"
          onClick={() => {
            navigate(`/${school}/${course_code}/${canvas_id}`);
          }}
        >
          Go Back
        </button>
      </div>

      <div className="content">
        {/* --------------------------------------------------------------------- */}
        {/* Currently Generating Accessible Video Packages (if any) */}
        {/* --------------------------------------------------------------------- */}
        {processingResults.length > 0 && (
          <div className="video-packages">
            <label className="section-label" htmlFor="videoLinks">
              <img
                src="/clock.svg"
                alt="clock icon"
                className="video_link_logo"
              />
              Currently Generating Accessible Video Packages
            </label>
            <table className="video-table-processing">
              <thead>
                <tr>
                  <th>Video URL</th>
                  <th>Created Time</th>
                  <th>Current Percentage</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {processingResults.map((item, index) => {
                  const percentage =
                    item.status && item.status.Progress !== undefined
                      ? item.status.Progress
                      : null;
                  const message =
                    item.status && item.status.State
                      ? item.status.State
                      : "Processing...";

                  return (
                    <tr key={index}>
                      <td
                        style={{
                          width: "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <a
                          href={item.video_url}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {item.video_url}
                        </a>
                      </td>
                      <td>{new Date(item.created_at).toLocaleString()}</td>
                      <td
                        style={{
                          width: "200px",
                          position: "relative",
                          left: "50px",
                        }}
                      >
                        {percentage !== null ? (
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <progress
                              value={percentage}
                              max={100}
                              style={{ width: "80px", marginRight: "8px" }}
                            />
                            <span>{percentage}%</span>
                          </div>
                        ) : (
                          <span>{`0`}%</span>
                        )}
                      </td>
                      <td
                        style={{
                          width: "200px",
                          whiteSpace: "normal", // or "pre-wrap"
                          wordWrap: "break-word",
                        }}
                      >
                        {message}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className="white-space"></div>
          </div>
        )}

        {/* --------------------------------------------------------------------- */}
        {/* Previously Generated Accessible Video Packages */}
        {/* --------------------------------------------------------------------- */}
        <div className="video-packages">
          <label className="section-label" htmlFor="videoLinks">
            <img
              src="/clock.svg"
              alt="clock icon"
              className="video_link_logo"
            />
            Previously Generated Accessible Video Packages
          </label>
          <table className="video-table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Duration</th>
                <th>Video Author</th>
                <th>Date</th>
                <th>Video Package URL</th>
                <th>Interactive Player URL</th>
              </tr>
            </thead>
            <tbody>
              {finishedResults.length === 0 ? (
                <tr>
                  <td colSpan={6} style={{ textAlign: "center" }}>
                    No finished videos available.
                  </td>
                </tr>
              ) : (
                finishedResults.map((item, index) => {
                  const videoInfo = item.video_info?.[0];
                  if (!videoInfo) {
                    return (
                      <tr key={index}>
                        <td colSpan={6} style={{ textAlign: "center" }}>
                          No video information available.
                        </td>
                      </tr>
                    );
                  }

                  return (
                    <tr key={index}>
                      <td>{videoInfo.Title}</td>
                      <td>{videoInfo.Duration.split(".")[0]}</td>
                      <td>{videoInfo.Author}</td>
                      <td>{new Date(item.created_at).toLocaleDateString()}</td>
                      <td>
                        <a
                          href={videoInfo["Output Folder URL"]}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={videoInfo["Output Folder URL"]}
                        >
                          {videoInfo["Output Folder URL"]}
                        </a>
                      </td>
                      <td>
                        <a
                          href={videoInfo["Interactive HTML File URL"]}
                          target="_blank"
                          rel="noopener noreferrer"
                          title={videoInfo["Interactive HTML File URL"]}
                        >
                          {videoInfo["Interactive HTML File URL"]}
                        </a>
                      </td>
                    </tr>
                  );
                })
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Result;
